import { InjectionToken } from '@angular/core';

export type EInvoiceFormatStatus = 'released' | 'preview' | 'deprecated';
export type EInvoiceDocumentType = 'invoice' | 'order' | 'despatchadvice';

export interface EInvoiceModelBinding {
  modelId: string;
  modelName: string;
}

export interface EInvoiceSyntaxBinding {
  syntax: string;
  modelBindings: EInvoiceModelBinding[];
}

export interface EInvoiceFormatDefinition {
  id: string;
  name: string;
  version?: string;
  status?: EInvoiceFormatStatus;
  documentType?: EInvoiceDocumentType;
  syntaxBindings: EInvoiceSyntaxBinding[];
}

export interface EInvoiceFormatMatch {
  id: string;
  name: string;
  syntax: string;
  version: string;
  status: EInvoiceFormatStatus;
  documentType?: EInvoiceDocumentType;
  modelBindings?: EInvoiceModelBinding[];
}

export interface EInvoiceValidationMessage {
  id?: string;
  message: string;
  location?: unknown | null;
}

export interface EInvoiceValidationStepResult {
  valid: boolean;
  name?: string;
  type?: string;
  errors: EInvoiceValidationMessage[];
  warnings?: EInvoiceValidationMessage[];
}

export interface EInvoiceValidationResult {
  valid: boolean;
  errors: EInvoiceValidationMessage[];
  stepResults: EInvoiceValidationStepResult[];
  matchedFormat?: EInvoiceFormatMatch;
}

export interface EInvoiceTransformationError {
  message: string;
}

export interface EInvoiceModelValidationError {
  message: string;
  location?: string;
  data?: unknown;
}

export interface EInvoiceImportResult {
  success: boolean;
  model?: unknown;
  errors: EInvoiceTransformationError[];
  transformationErrors: EInvoiceTransformationError[];
  modelValidationErrors: EInvoiceModelValidationError[];
}

export interface EInvoiceExportResult {
  success: boolean;
  document?: Uint8Array;
  errors: EInvoiceTransformationError[];
  transformationErrors: EInvoiceTransformationError[];
  modelValidationErrors: EInvoiceModelValidationError[];
}

export interface EinvoiceProcessingEngine {
  init?(): Promise<void>;
  probe(xml: string, options: {
    formatId?: string;
    syntax?: string;
    version?: string;
  }): Promise<EInvoiceFormatMatch[]>;
  validate(xml: string, options: {
    formatId?: string;
    syntax?: string;
    version?: string;
  }): Promise<EInvoiceValidationResult>;
  importToModel(xml: string, formatId: string, version: string, syntax: string, modelId: string, trackSource?: boolean): Promise<EInvoiceImportResult>;
  exportFromModel(model: unknown, formatId: string, version: string, syntax: string, modelId: string): Promise<EInvoiceExportResult>;
  getModelSchema(formatId: string, version: string, syntax: string, modelId: string): Promise<string | null>;
  getFormats(): Promise<EInvoiceFormatDefinition[]>;
}

export const EINVOICE_PROCESSING_ENGINE = new InjectionToken<EinvoiceProcessingEngine>('EinvoiceProcessingEngine');
